// Cart Functions


if ((typeof Shopify) === 'undefined') {
    var Shopify = {};
}

Shopify.updateMessage = function(body, header) {
$('.cart_overlay').fadeIn(200).delay(1000).fadeOut(200);
  $('.variant_overlay').fadeIn(200).delay(1000).fadeOut(200,function(){
  $('#cart_updated_message').fadeIn(200).delay(1500).fadeOut(200);
});

};

Shopify.updateCartInfo = function(cart, cart_summary_id, cart_count_id) {
    // Update cart count.
    var dollar_price = Shopify.formatMoney(cart.total_price);
    
    var formatted_price = dollar_price.replace('$', '£');

    if ((typeof cart_count_id) === 'string') {
		if (cart.item_count == 0) { 
			jQuery('#' + cart_count_id).html('<i>0 items / </i>&pound;0.00');
		}
		else if (cart.item_count == 1) {
			jQuery('#' + cart_count_id).html('<i>1 item / </i>' + formatted_price);
		}
		else {
			jQuery('#' + cart_count_id).html('<i>' + cart.item_count + ' items / </i>' + formatted_price);
		}
	} 
	
	
};

Shopify.updateProductInfo = function(product, product_summary_id) {
	if ((typeof product_summary_id) === 'string') {
		var product_summary = jQuery('#' + product_summary_id);
		if (product_summary.length) {
			// Start from scratch.
			product_summary.empty();
			// Pull it all out.
			jQuery.each(product, function(key, value) {
				if (key === 'variants') {
					jQuery('<dt>Variants</dt><dd class="items"><ul class="variants"></ul></dd>').appendTo(product_summary);
					var ul = jQuery('#' + product_summary_id + ' ul.variants');
					if (value.length) {
						jQuery.each(value, function(i, item) {						
							jQuery('<li>' + item.title + ' (sku: ' + item.sku + ') <small>' + item.inventory_quantity + ' in stock</small></li>').appendTo(ul);
						});
					}
					else {
						jQuery('<li>This product has no variant.</li>').appendTo(ul);
					}
				}
				else if (key === 'options') {
					jQuery('<dt>Options</dt><dd class="items"><ul class="options"></ul></dd>').appendTo(product_summary);
					var ul = jQuery('#' + product_summary_id + ' ul.options');
					if (value.length) {
						jQuery.each(value, function(i, item) {						
							jQuery('<li>' + item.name + '</li>').appendTo(ul);
						});
					}
					else {
						jQuery('<li>This product has no options.</li>').appendTo(ul);
					}
				}
				else {
					jQuery('<dt>' + key + '</dt><dd>' + value + '</dd>').appendTo(product_summary);
				}
			});
		}
	}
};

jQuery(function() {
	// Let's get the cart and show what's in it in the cart box.	
	Shopify.getCart(function(cart) {
		Shopify.updateCartInfo(cart, 'cart-info');		
	});
});

Shopify.onError = function(XMLHttpRequest, textStatus) {
	// Shopify returns a description of the error in XMLHttpRequest.responseText.
	// It is JSON.
	var data = eval('(' + XMLHttpRequest.responseText + ')');
	Shopify.updateMessage(data.description, data.message + ' (' + data.status	 + ')');
};
		
Shopify.onItemAdded = function(line_item) {	 
	Shopify.updateMessage('You now have ' + line_item.quantity + ' &quot;' + line_item.title + '&quot; in your cart.', '');
	Shopify.getCart();
};
		
Shopify.onCartUpdate = function(cart) {
	Shopify.updateCartInfo(cart, 'cart-info', 'shopping-cart');
};

Shopify.onProduct = function(product) {
	Shopify.updateProductInfo(product, 'product-info');
};

$(document).ready(function() {
	Shopify.getCart();
});




/**
 * Module to show Recently Viewed Products
 *
 * Copyright (c) 2011 Caroline Schnapp (11heavens.com)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 */
 
Shopify.Products=(function(){var a={howManyToShow:3,howManyToStoreInMemory:10,wrapperId:"recently-viewed-products",templateId:"recently-viewed-product-template",onComplete:null};var b={configuration:{expires:90,path:"/",domain:window.location.hostname},name:"shopify_recently_viewed",write:function(c){jQuery.cookie(this.name,c.join(" "),this.configuration)},read:function(){var c=[];var d=jQuery.cookie(this.name);if(d!==null){c=d.split(" ")}return c},destroy:function(){jQuery.cookie(this.name,null,this.configuration)}};return{showRecentlyViewed:function(h){var h=h||{};jQuery.extend(a,h);var g=b.read();var c=Math.min(g.length,a.howManyToShow);if(c){var f=jQuery("#"+a.templateId);var j=jQuery("#"+a.wrapperId);if(f.length&&j.length){var d=0;for(var e=0;e<c;e++){jQuery.getJSON("/products/"+g[e]+".js",function(k){f.tmpl(k).appendTo(j);d++;if(d===c){j.show();if(a.onComplete){try{a.onComplete()}catch(i){}}}})}}}},getConfig:function(){return a},clearList:function(){b.destroy()},recordRecentlyViewed:function(g){var g=g||{};jQuery.extend(a,g);var e=b.read();if(window.location.pathname.indexOf("/products/")!==-1){var f=window.location.pathname.match(/\/products\/([a-z0-9\-]+)/)[1];var c=jQuery.inArray(f,e);if(c===-1){var d=e.unshift(f);e=e.splice(0,a.howManyToStoreInMemory)}else{e.splice(c,1);e.unshift(f)}b.write(e)}}}})();


$(document).ready(function() {
	$('.responsive-nav-toggle').click(function(e) {
      	e.preventDefault;
		$('.responsive-nav nav').slideToggle(600);
	});
});

function setEqualHeight(columns) 
{
	var tallestcolumn = 0;
	columns.each(
		function() 
		{
			currentHeight = $(this).height();
			if(currentHeight > tallestcolumn) 
			{
				tallestcolumn = currentHeight;
			}
		}
	);
	columns.height(tallestcolumn);
}
$(window).load(function(){
	setEqualHeight($(".section-blocks .col"));
  	setEqualHeight($(".col .info"));
});

window.onresize = OnResizeDocument;
function OnResizeDocument () {
	$(".section-blocks .col").css('height', 'auto')
    $(".col .info").css('height', 'auto')
	setEqualHeight($(".section-blocks .col"));
  	setEqualHeight($(".col .info"));
}